/* eslint-disable */
if (process.env.ROOT) {
    __webpack_public_path__ = process.env.ROOT;
}
